import { registerWeapon } from './registry';
import { AXE_SPLIT_CRATER } from '../terrain/crater-shapes';

export const DIGGER = registerWeapon({
  id: 'digger',
  name: 'Digger',
  description: 'Zero damage. Splits the earth wide open. Drop them to the void.',
  tier: 'COMMON',
  rarity: 'common',
  projectileRadius: 6,
  projectileSpeed: 0.55,
  color: 0x88ff44,
  gravity: 0.15,
  bounces: 0,
  bounceEnergyRetention: 0.85,
  damage: 0,
  blastRadius: 160,
  knockbackMult: 0.01,
  knockbackRadius: 0.5,
  shakeIntensity: 1.8,
  particleScale: 1.8,
  craterShape: AXE_SPLIT_CRATER,
  canDestroyWireframe: true,
  wireframeDamageScale: 0.5,
});
